import React, { ChangeEvent, Component } from "react";

interface Prop {
	id: string;
	onLabel: string;
	offLabel: string;
	onIcon?: React.ReactElement;
	offIcon?: React.ReactElement;
	value: boolean;
	onChange?: ( value: boolean ) => void;
	extraContainerClass?: string;
}

interface State {
	value: boolean;
}

interface StateMulti {
	value: string;
}


interface PropMulti {
	id: string;
	value: string;
	onChange?: ( value: string ) => void;
	extraContainerClass?: string;
	items: { id: string; label: string; icon?: React.ReactElement }[];
}

class SwitchMulti extends Component<PropMulti, StateMulti> {
	static defaultProps: Partial<Prop> = {
		extraContainerClass: ""
	};

	constructor( props: PropMulti ) {
		super( props );
		this.state = {
			value: props.value,
		};
	}

	static getDerivedStateFromProps( nextProps: Readonly<Prop> ) {
		return {
			value: nextProps.value,
		};
	}

	render() {
		const { value } = this.state;
		const { items } = this.props;
		const commonCLass = "btn btn-sm";
		return (
			<div className={ "btn-group btn-toggle btn-custom-toggle " + this.props.extraContainerClass }>
				{
					items.map( i => {
						const on = value === i.id + "";
						return <button
							key={ i.id }
							type="button" className={ commonCLass + `${ on ? " active" : "" }` }
							onClick={ () => this.on( i.id ) }>{ i.icon }{ i.label }</button>;
					} )
				}
			</div>
		);
	}

	on = ( id: string ) => {
		this.setVal( id );
	};

	setVal( id: string ) {
		this.setState( {
			value: id,
		} );
		if ( this.props.onChange ) this.props.onChange( id );
	}
}

class Switch extends Component<Prop, State> {
	static defaultProps: Partial<Prop> = {
		extraContainerClass: ""
	};

	constructor( props: Prop ) {
		super( props );
		this.state = {
			value: props.value,
		};
	}

	static getDerivedStateFromProps( nextProps: Readonly<Prop>, prevState: State ) {
		return {
			value: nextProps.value,
		};
	}

	render() {
		const { value } = this.state;
		const commonCLass = "btn btn-sm ";
		const onClass = value ? "active" : "";
		const offClass = value ? "" : " active";
		return (
			<div className={ "btn-group btn-toggle btn-custom-toggle " + this.props.extraContainerClass }>
				{ this.props.children }
				<button
					type="button" className={ commonCLass + offClass }
					onClick={ this.off }>{ this.props.offIcon }{ this.props.offLabel }</button>
				<button
					type="button" className={ commonCLass + onClass }
					onClick={ this.on }>{ this.props.onIcon }{ this.props.onLabel }</button>
			</div>
		);
	}

	off = () => {
		this.setVal( false );
	};
	on = () => {
		this.setVal( true );
	};

	setVal( value: boolean ) {
		this.setState( {
			value: value,
		} );
		if ( this.props.onChange ) this.props.onChange( value );
	}

	onChange = ( e: ChangeEvent<HTMLInputElement> ) => {
		if ( this.props.onChange ) this.props.onChange( e.target.checked );
	};
}

export default Switch;
export { SwitchMulti };